window.IframeLogin = {
  init: function(arg, done) {
    var iframeLogin;
    iframeLogin = arg.iframeLogin;
    this.authenticated = iframeLogin != null ? iframeLogin.authenticated : void 0;
    if (this.authenticated == null) {
      this.authenticated = true;
    }
    if (this.authenticated) {
      return typeof done === "function" ? done() : void 0;
    }
    return $((function(_this) {
      return function() {
        _this.$modal = $('#login-modal');
        _this.$iframe = _this.$modal.find('iframe');
        _this.iframeName = _this.$iframe.attr('name');
        IframeLogin.reloadBindings();
        return typeof done === "function" ? done() : void 0;
      };
    })(this));
  },
  go: function(path, data) {
    var key, value;
    if (data) {
      path += "?ref=" + (encodeURIComponent(this.destination));
      for (key in data) {
        value = data[key];
        path += "&" + key + "=" + value;
      }
    }
    return window.location.assign(path);
  },
  reloadBindings: function(el) {
    if (el == null) {
      el = document.body;
    }
    return $(el).find('[data-login-required]').on('click', function(e) {
      var $this;
      e.preventDefault();
      $this = $(this);
      return IframeLogin.openModal($this.attr('href'));
    });
  },
  openModal: function(path) {
    var ref;
    this.destination = path;
    GIG.Modal.open({
      el: this.$modal
    });
    try {
      return (ref = frames[this.iframeName]) != null ? ref.IframeLogin.iframeView.resetHeight() : void 0;
    } catch (error) {
      return window.location.assign(path);
    }
  },
  success: function(data) {
    return window.location.assign(this.destination);
  },
  updateHeight: function(height) {
    return this.$iframe.attr('height', height);
  }
};

